import {callApi} from './api';

import {LocationTypeDto} from '@kontactless/admin-api/location-type/location-type.dto';

export async function fetchLocationTypesRequest(token: string, storeId: number): Promise<LocationTypeDto[]> {
  return callApi<LocationTypeDto[]>(`/location-types`, {token, params: {storeId}}).then(({data}) => data);
}
